/* Colborne Dental | Phase 2 - above-the-fold reveal guard. Added 2026-08-23.

   The hand-built sections across this site animate in with an
   IntersectionObserver: elements start at opacity 0 and gain an "is-in"
   class once they intersect. On a campaign landing page that means a paid
   visitor can arrive to a hero that is still fading up, or blank if the
   observer is late. Below-the-fold animation is worth keeping; above the
   fold it costs money.

   This reveals anything already inside the first viewport immediately, and
   nets anything still hidden shortly after, without removing the animation
   for content further down the page. */
(function () {
  'use strict';

  if (window.CDReveal) { return; }

  var SEL = '[class*="-rev"],[class*="reveal"]';

  function reveal(el) {
    if (!el.classList.contains('is-in')) { el.classList.add('is-in'); }
  }

  function revealWithin(multiplier) {
    var limit = window.innerHeight * multiplier;
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('is-in')) { continue; }
      var top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      if (top < limit) { reveal(el); }
    }
  }

  function run() {
    /* immediate: everything in the first screen */
    revealWithin(1.15);
    /* shortly after: safety net two screens deep, in case the observer
       never fires (slow network, reduced motion, script error upstream) */
    setTimeout(function () { revealWithin(2); }, 900);
    setTimeout(function () { revealWithin(2); }, 2200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', function () { revealWithin(1.15); });

  window.CDReveal = { revealWithin: revealWithin };
})();
